<template>
  <!-- 点亮：彩色六边形加白色图案；没点亮：浅灰底加灰色图案，下一枚要拿的用虚线圈出来 -->
  <svg class="milestone-badge" :class="{ earned, next }" viewBox="0 0 64 72" :style="{ '--badge': badge.color }" aria-hidden="true">
    <path class="badge-frame" :d="BADGE_FRAME" />
    <path class="badge-inner" :d="BADGE_INNER" />
    <path v-for="d in badge.fill" :key="d" class="badge-fill" :d="d" />
    <path v-for="d in badge.inner || []" :key="d" class="badge-core" :d="d" />
    <path v-for="d in badge.stroke" :key="d" class="badge-line" :d="d" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { BADGE_FRAME, BADGE_INNER, MILESTONE_BADGES } from '@/data/milestoneBadges'

const props = defineProps({
  index: { type: Number, required: true },
  earned: { type: Boolean, default: false },
  next: { type: Boolean, default: false }
})
const badge = computed(() => MILESTONE_BADGES[props.index])
</script>

<style scoped>
.milestone-badge {
  display: block;
  overflow: visible;
}

.badge-frame {
  fill: rgba(16, 24, 32, 0.05);
  stroke: rgba(16, 24, 32, 0.05);
  stroke-width: 6;
  stroke-linejoin: round;
}

.badge-inner {
  fill: none;
  stroke: rgba(16, 24, 32, 0.08);
  stroke-width: 1.5;
  stroke-linejoin: round;
}

.badge-fill,
.badge-core {
  fill: rgba(16, 24, 32, 0.2);
}

.badge-line {
  fill: none;
  stroke: rgba(16, 24, 32, 0.2);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* 下一枚：外框换成虚线，提示正在朝它走 */
.next .badge-frame {
  stroke: rgba(16, 24, 32, 0.22);
  stroke-width: 2;
  stroke-dasharray: 4 4;
}

.earned .badge-frame {
  fill: var(--badge);
  stroke: var(--badge);
}

.earned .badge-inner {
  stroke: rgba(255, 255, 255, 0.35);
}

.earned .badge-fill {
  fill: #fff;
}

.earned .badge-core {
  fill: var(--badge);
}

.earned .badge-line {
  stroke: #fff;
}
</style>
